import { render, staticRenderFns } from "./draggable.vue?vue&type=template&id=656e5e9a"
import script from "./draggable.vue?vue&type=script&lang=js"
export * from "./draggable.vue?vue&type=script&lang=js"
import style0 from "./draggable.vue?vue&type=style&index=0&id=656e5e9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports